/** পেমেন্ট অ্যাকাউন্ট, পেমেন্ট ও স্থানান্তর। */
export const payments = {
    accounts: {
        title: "পেমেন্ট অ্যাকাউন্ট",
        description: "ক্যাশ ড্রয়ার, ব্যাংক অ্যাকাউন্ট ও মোবাইল ওয়ালেট। ব্যালেন্স পেমেন্ট থেকে হিসাব হয়।",
        empty: "এখনো কোনো পেমেন্ট অ্যাকাউন্ট নেই।",
        add: "অ্যাকাউন্ট যোগ",
        edit: "অ্যাকাউন্ট সম্পাদনা",
        name: "নাম",
        type: "ধরন",
        location: "লোকেশন",
        register: "রেজিস্টার",
        accountNumber: "অ্যাকাউন্ট বা ওয়ালেট নম্বর",
        opening: "শুরুর ব্যালেন্স",
        balance: "ব্যালেন্স",
        archive: "আর্কাইভ",
        archived: "আর্কাইভ করা",
        saved: "অ্যাকাউন্ট সংরক্ষিত হয়েছে।",
        tenantWide: "সব লোকেশন",
        types: {
            cash_drawer: "ক্যাশ ড্রয়ার",
            cash: "নগদ",
            bank: "ব্যাংক",
            bkash: "বিকাশ",
            nagad: "নগদ (মোবাইল)",
            rocket: "রকেট",
            other: "অন্য",
        },
    },
    list: {
        title: "পেমেন্ট",
        description: "আপনার অ্যাকাউন্টে টাকা আসা-যাওয়া। ভুল হলে বাতিল করা হয়, কখনো বদলানো হয় না।",
        empty: "এখনো কোনো পেমেন্ট নেই।",
        record: "পেমেন্ট লিখুন",
        transfer: "টাকা সরান",
        filters: {
            account: "অ্যাকাউন্ট",
            method: "মাধ্যম",
            verification: "যাচাই",
            reference: "ট্রানজেকশন আইডি / রেফারেন্স",
            any: "সব",
        },
        columns: {
            number: "পেমেন্ট",
            date: "তারিখ",
            account: "অ্যাকাউন্ট",
            method: "মাধ্যম",
            reference: "রেফারেন্স",
            amount: "পরিমাণ",
            verification: "যাচাই",
        },
    },
    direction: { in: "টাকা এসেছে", out: "টাকা গেছে" },
    methods: {
        cash: "নগদ",
        bkash: "বিকাশ",
        nagad: "নগদ (মোবাইল)",
        rocket: "রকেট",
        bank_transfer: "ব্যাংক ট্রান্সফার",
        card: "কার্ড",
        cheque: "চেক",
        other: "অন্য",
    },
    verification: {
        not_required: "দরকার নেই",
        pending: "অপেক্ষায়",
        verified: "যাচাইকৃত",
        failed: "ব্যর্থ",
    },
    form: {
        title: "পেমেন্ট লিখুন",
        account: "অ্যাকাউন্ট",
        direction: "দিক",
        amount: "পরিমাণ",
        method: "মাধ্যম",
        reference: "ট্রানজেকশন আইডি / রেফারেন্স",
        note: "নোট",
        order: "অর্ডার {{number}}-এর জন্য",
        save: "লিখুন",
        saved: "পেমেন্ট {{number}} লেখা হয়েছে।",
        duplicate: "এই ট্রানজেকশন আইডি আগেও ব্যবহার হয়েছে: {{numbers}}। একই পেমেন্ট কিনা দেখে নিন।",
    },
    actions: {
        reverse: "বাতিল",
        reverseReason: "কেন বাতিল করছেন?",
        reversed: "পেমেন্ট বাতিল হয়েছে।",
        verify: "যাচাইকৃত",
        fail: "ব্যর্থ",
        verifiedDone: "যাচাই সংরক্ষিত হয়েছে।",
    },
    transfer: {
        title: "অ্যাকাউন্টের মধ্যে টাকা সরান",
        from: "থেকে",
        to: "যেখানে",
        amount: "পরিমাণ",
        note: "নোট",
        save: "সরান",
        saved: "স্থানান্তর {{number}} সংরক্ষিত হয়েছে।",
    },
    order: {
        title: "পেমেন্ট",
        empty: "এই অর্ডারের এখনো কোনো পেমেন্ট নেই।",
        due: "এখনো বাকি: {{amount}}",
    },
    linked: {
        account: "পেমেন্ট অ্যাকাউন্ট",
        none: "কোনো অ্যাকাউন্ট থেকে নয়",
    },
    reversedBadge: "বাতিল",
    reversalOf: "বাতিলের এন্ট্রি",
};
//# sourceMappingURL=payments.js.map